module.exports = __webpack_public_path__ + "img/item_bg2.48a98c11.png";